<template>
  <div v-if="visible" class="recent-visit-warning-overlay" @click.self="handleCancel">
    <div class="recent-visit-warning-modal" role="dialog" aria-modal="true" aria-labelledby="recent-visit-title">
      <div class="modal-header">
        <i class="ico warning-icon">⚠️</i>
        <h3 id="recent-visit-title">Visite récente détectée</h3>
      </div>

      <div class="modal-body">
        <p>
          Une visite a déjà été effectuée le
          <strong>{{ formattedDate }}</strong>
          <span v-if="daysAgo !== null">
            (il y a <strong>{{ daysAgo }} jour{{ daysAgo > 1 ? 's' : '' }}</strong>)
          </span>.
        </p>
        <p class="modal-hint">
          Souhaitez-vous tout de même créer une nouvelle visite pour ce logement&nbsp;?
        </p>
      </div>

      <div class="modal-footer">
        <button
          class="btn-cancel"
          @click="handleCancel"
        >
          Annuler
        </button>
        <button
          class="btn-confirm"
          @click="handleConfirm"
        >
          Continuer quand même
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'RecentVisitWarningModal',

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    lastVisitDate: {
      type: String,
      default: null
    }
  },

  emits: ['confirm', 'cancel'],

  computed: {
    formattedDate() {
      if (!this.lastVisitDate) return ''
      return moment(this.lastVisitDate).format('DD/MM/YYYY')
    },

    daysAgo() {
      if (!this.lastVisitDate) return null
      return moment().diff(moment(this.lastVisitDate), 'days')
    }
  },

  methods: {
    handleConfirm() {
      this.$emit('confirm')
    },

    handleCancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped lang="scss">
.recent-visit-warning-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.recent-visit-warning-modal {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  max-width: 480px;
  width: 100%;
  overflow: hidden;
  animation: modal-in 0.2s ease;
}

@keyframes modal-in {
  from {
    opacity: 0;
    transform: translateY(-12px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1.25rem 1.5rem 1rem;
  border-bottom: 1px solid #f0d080;
  background: #fffbea;

  .warning-icon {
    font-style: normal;
    font-size: 1.5rem;
    line-height: 1;
  }

  h3 {
    margin: 0;
    font-size: 1.1rem;
    font-weight: 700;
    color: #7a5a00;
  }
}

.modal-body {
  padding: 1.25rem 1.5rem;

  p {
    margin: 0 0 0.6rem;
    font-size: 0.95rem;
    color: #333;
    line-height: 1.5;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .modal-hint {
    color: #555;
    font-size: 0.9rem;
  }
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid #eee;
  background: #fafafa;

  button {
    padding: 0.5rem 1.25rem;
    border-radius: 5px;
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    border: none;
    transition: background 0.2s, color 0.2s;
    white-space: nowrap;
  }

  .btn-cancel {
    background: #fff;
    color: #444;
    border: 1px solid #ccc;

    &:hover {
      background: #f0f0f0;
    }
  }

  .btn-confirm {
    background: #3273dc;
    color: #fff;

    &:hover {
      background: #2366d1;
    }
  }
}
</style>
